




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import NavItem from './nav-item.vue';

@Component({
  components: { NavItem }
})
export default class Nav extends Vue {
  idx = 1;
  // data() {
  //   return {};
  // }
  @Prop({ default: null, type: Array })
  items: any;
  beforeMount() {
    const { params: { hkey } } = this.$route;
    // console.log('------------->');
  }
  onNavigation(idx: number) {
    this.idx = idx + 1;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/navigation/nav.vue